import { render, staticRenderFns } from "./registered-trading-system-vendors.vue?vue&type=template&id=87e08936"
import script from "./registered-trading-system-vendors.vue?vue&type=script&lang=js"
export * from "./registered-trading-system-vendors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./registered-trading-system-vendors.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,LoadingAnimation: require('/vercel/path0/components/ui/LoadingAnimation.vue').default,BaseCard: require('/vercel/path0/components/ui/BaseCard.vue').default})
